import apiClient from '@/utils/apiClient';

const CREATE_CONTACT_SALES_LEAD = '/api/reseller/contact-sales';

export const createContactSalesLead = async (formData) => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CREATE_CONTACT_SALES_LEAD,
		body: formData,
	});
	return response;
};
